var React = require('react');

function GlassMartini (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M405.12 64L256 213.13 106.84 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M502 57.6C523.28 36.34 508.23 0 478.18 0H33.78C3.73 0-11.32 36.34 10 57.6l214 214V464h-56a40 40 0 0 0-40 40 8 8 0 0 0 8 8h240a8 8 0 0 0 8-8 40 40 0 0 0-40-40h-56V271.64zM256 213.13L106.84 64h298.28z","className":"fa-primary","key":2})]);
}

GlassMartini.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = GlassMartini;

GlassMartini.default = GlassMartini;
